import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "calendar__menu__year-selector flex flex-col" }
const _hoisted_2 = {
  "data-test": "calendar-header",
  class: "flex flex-none items-center gap-6"
}
const _hoisted_3 = { class: "calendar-header flex items-start justify-between user-select-none" }
const _hoisted_4 = {
  class: "headlines--headline-04 capitalize-text flex justify-content-center align-content-start",
  "data-test": "calendar-header-years-list"
}
const _hoisted_5 = { class: "calendar__menu__years flex-auto grid user-select-none" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["data-test"]

import CoreChipAction from 'frontcore/views/chips/chip/views/CoreChipAction.vue'
import i18n from 'frontcore/i18n'
import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import useCalendarHeader from 'frontcore/presentation/calendar/domain/useCalendarHeader'
import { CalendarModeOptions } from 'frontcore/presentation/calendar/domain/types'
import { toRefs, watch } from 'vue'

interface Props {
  mode: number
  month: number
  selectionMode: number
  year: number
  disablePastDays?: boolean
}

const numberOfVisibleYears = 9


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarHeaderYearSelector',
  props: {
    mode: {},
    month: {},
    selectionMode: {},
    year: {},
    disablePastDays: { type: Boolean, default: false }
  },
  emits: ["update:month", "update:year", "update:mode", "select:year", "today"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const { selectionMode } = toRefs(props)

const emit = __emit

const {
  viewmodel,
  goToYear,
  goToToday,
  nextYearList,
  previousYearList,
  setCalendarHeaderInfo,
  showTodayButton,
} = useCalendarHeader(
  props.mode,
  props.month,
  props.year,
  numberOfVisibleYears,
  selectionMode
)

watch(
  () => props.mode,
  () => {
    setCalendarHeaderInfo(props.month, props.year)
  }
)

const previous = () => {
  previousYearList()
  emit('update:year', viewmodel.year)
  emit('update:month', viewmodel.month)
}

const next = () => {
  nextYearList()
  emit('update:year', viewmodel.year)
  emit('update:month', viewmodel.month)
}

const moveToToday = () => {
  goToToday()
  emit('update:year', viewmodel.year)
  emit('update:month', viewmodel.month)
  emit('update:mode', viewmodel.mode)
  emit('today')
}

const selectYear = (yearValue: number) => {
  if (isDisabled(yearValue)) { return }
  goToYear(yearValue)
  emit('update:year', viewmodel.year)
  emit('update:mode', viewmodel.mode)
  emit('select:year', yearValue)
}
const { t } = i18n.global

const isSelected = (yearValue: number) => {
  return props.year === yearValue
}

const isDisabled = (yearValue: number) => {
  return props.disablePastDays && yearValue < new Date().getFullYear()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(CoreChipAction, {
        label: _unref(t)('common.messages.today'),
        class: "core-calendar__menu__header-action",
        dataTest: "calendar-today-chip",
        onClick: moveToToday
      }, null, 8, ["label"]), [
        [_vShow, _unref(showTodayButton)]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SVGIcon, {
          class: "pointer",
          iconName: "ChevronLeft",
          "data-test": "calendar-header-previous-years-icon",
          onClick: previous
        }),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(viewmodel).yearList[0]) + " - " + _toDisplayString(_unref(viewmodel).yearList[numberOfVisibleYears-1]), 1),
        _createVNode(SVGIcon, {
          class: "pointer",
          iconName: "ChevronRight",
          "data-test": "calendar-header-next-years-icon",
          onClick: next
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewmodel).yearList, (yearValue) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `calendar-select-year-${yearValue}`,
          class: _normalizeClass([[{
          'bg-core-primary-80': isSelected(yearValue),
          'calendar__menu__year__item--disabled': isDisabled(yearValue)
        }], "calendar__menu__year__item flex items-center justify-center"]),
          onClick: ($event: any) => (selectYear(yearValue))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["buttons--button-01 uppercase-text text-core-primary-10", {
            'calendar__menu__year__name--disabled': isDisabled(yearValue)
          }]),
            "data-test": `calendar-select-year-${yearValue}`
          }, _toDisplayString(yearValue), 11, _hoisted_7)
        ], 10, _hoisted_6))
      }), 128))
    ])
  ]))
}
}

})